import BreadcrumbTwo from '../../components/Breadcrumbs/BreadcrumbTwo';
import DefaultLayout from '../../layout/DefaultLayout';
import EconomicActivityTable from './EconomicActivityTable';

const EconomicActivities = () => {
  return (
    <DefaultLayout>
      <BreadcrumbTwo />
      <EconomicActivityTable />
    </DefaultLayout>
  );
};

export default EconomicActivities;
